import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setShowDailyRewardsModal } from 'actions/global-actions';

import { CalendarModal } from './components/CalendarModal';
import { RewardHistoryModal } from './components/RewardHistoryModal';
import { YouWonModal } from './components/YouWonModal';

import { useClaimDailyReward } from './hooks/useClaimDailyReward';
import { useDailyRewardsModals } from './hooks/useDailyRewardsModals';

import { ClaimRewardApiResponse } from './dailyRewards.models';
import { IState } from 'models/reducers/i-state.interface';

const DailyRewards = () => {
  const dispatch = useDispatch();
  const dailyRewardsModal = useSelector((state: IState) => state.global.showDailyRewardsModal);
  const { activeModal, hasPrevious, switchTo, close, goBack } = useDailyRewardsModals('calendar');
  const claimMutation = useClaimDailyReward();
  const [claimReward, setClaimReward] = useState<ClaimRewardApiResponse | null>(null);

  const now = new Date();
  const modalYear = dailyRewardsModal ? dailyRewardsModal.year : now.getFullYear();
  const modalMonth = dailyRewardsModal ? dailyRewardsModal.month : now.getMonth() + 1;
  const isCurrentMonth = modalYear === now.getFullYear() && modalMonth === now.getMonth() + 1;

  const handleClose = () => {
    close();
    dispatch(setShowDailyRewardsModal(false));
  };

  const handleClaimReward = () => {
    claimMutation.mutate(undefined, {
      onSuccess: (data) => {
        setClaimReward(data);
        switchTo('youWon');
      },
    });
  };

  return (
    <>
      {activeModal === 'calendar' && (
        <CalendarModal
          onClose={handleClose}
          onClaimReward={handleClaimReward}
          onRewardHistory={() => switchTo('history')}
          isClaimPending={claimMutation.isPending}
          claimCooldownUntil={claimMutation.cooldownUntil}
          year={modalYear}
          month={modalMonth}
          isCurrentMonth={isCurrentMonth}
        />
      )}

      {activeModal === 'history' && (
        <RewardHistoryModal onClose={handleClose} onPrevious={hasPrevious ? goBack : undefined} />
      )}

      {activeModal === 'youWon' && (
        <YouWonModal
          onClose={handleClose}
          onClaimReward={() => switchTo('calendar')}
          rewardName={claimReward?.reward?.prize.name}
          rewardIconUrl={claimReward?.reward?.vip_image_override || claimReward?.reward?.image_override || claimReward?.reward?.prize.icon_url}
          vipMultiplier={claimReward?.reward?.vip_multiplier}
          prizeKind={claimReward?.reward?.prize.kind}
        />
      )}
    </>
  );
};

export default DailyRewards;
